import React from 'react';
import { QRCodeSVG } from 'qrcode.react';

const PortalPromo = () => {
  const portalUrl = 'https://portal.kaafipay.so';

  const qrText = `${portalUrl}`;
  return (
    <div className="d-flex flex-column align-items-center justify-content-center vh-100 bg-light text-center p-4">
      {/* <img
        src="/logo.png" // Replace with your logo path
        alt="KTC Logo"
        style={{ width: 100, marginBottom: 20 }}
      /> */}

      <h1 className="mb-3 text-primary">KaafiPay Portal</h1>

      <QRCodeSVG value={qrText} size={180} />

      <p className="mt-4 fs-5 text-secondary">
        Manage your invoices and payments with ease.
        <br />
        Scan the QR code to get started!
      </p>

      <a
        href={portalUrl}
        className="btn btn-primary mt-3"
        target="_blank"
        rel="noopener noreferrer"
      >
        Visit Portal
      </a>
    </div>
  );
};

export default PortalPromo;
